import create from 'zustand';
import { BackendError, SignupBody } from '@oresundsbron/api';
import { SignupResponse } from '@oresundsbron/validators';

export type SignUpStore = {
  data?: SignupBody;
  resp?: SignupResponse;
  error?: BackendError;
  isPasswordSet: boolean;
  payWithCreditCard: boolean;
  token?: string;
};

export const useSignUp = create<SignUpStore>(() => ({
  isPasswordSet: false,
  payWithCreditCard: false,
}));

export const setRequestData = (data: SignupBody) =>
  useSignUp.setState((state) => ({ ...state, data }));

export const setResponse = (resp: SignupResponse) =>
  useSignUp.setState((state) => ({ ...state, resp, error: undefined }));

export const setError = (error?: BackendError) =>
  useSignUp.setState((state) => ({ ...state, error, resp: undefined }));

export const setIsPasswordSet = () =>
  useSignUp.setState((state) => ({ ...state, isPasswordSet: true }));

export const setPayWithCreditCard = () =>
  useSignUp.setState((state) => ({ ...state, payWithCreditCard: true }));

export const setToken = (token: string) =>
  useSignUp.setState((state) => ({ ...state, token: token }));

export const resetStore = () =>
  useSignUp.setState(() => ({
    isPasswordSet: false,
    payWithCreditCard: false,
    data: undefined,
    resp: undefined,
    error: undefined,
    token: undefined,
  }));
